import { type FC, memo } from "react";
import { type InputProps } from "@snapchat/snap-design-system/es/components/Input";
import { useInputState, type ErrorState, NullErrorState, useErrorMessages } from "../../core/validation";
import { DataInput } from "./VendorDataSection.styles";

interface VendorDataInputProps extends Omit<InputProps, "error"> {
    value: string;
    onChanged: (newValue: string, isValid: boolean) => void;
    isDuplicate?: ErrorState;
    validator?: (value: string) => boolean;
    error?: (value: string) => string | null;
}

export const VendorDataInput: FC<VendorDataInputProps> = memo(
    ({ value, onChanged, error, validator, isDuplicate = NullErrorState, ...inputProps }) => {
        const { inputProps: inputStateProps, isValid } = useInputState({
            defaultValue: value,
            error,
            validator,
            onChanged,
            showErrorByDefault: true,
        });

        const errorMessage = useErrorMessages([
            { isActive: !isValid, message: inputStateProps.error as string },
            isDuplicate,
        ]);

        return <DataInput {...inputStateProps} error={errorMessage} {...inputProps} />;
    },
);
